import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { Alignment, Variant, VariantTags, } from './typography.interfaces';
import css from "./typography.module.css";
const Typography = ({ variant = Variant.BODY_REGULAR, align = Alignment.LEFT, as: Tag = VariantTags[variant], className, children, ...props }) => {
    const classes = classNames(css.typography, css[variant], css[`align-${align}`], className);
    return (_jsx(Tag, { className: classes, ...props, children: children }));
};
Typography.displayName = 'Typography';
export { Typography };
